import useFetchFeatures from '../../../../hocs/useFetchFeatures';

export const useFetchFeaturesProvider = ({
                                           enabled,
                                           partIds,
                                           searchText,
                                           selectedFilters,
                                           useAllWizards = false,
                                         }) => {
  const safePartIds = enabled ? partIds : [];
  const safeSearch = enabled ? searchText : '';
  const safeFilters = enabled ? selectedFilters : {};

  const { featuresData, isLoading } = useFetchFeatures(
    safePartIds,
    safeSearch,
    safeFilters,
    true,
    false,
    useAllWizards,
  );

  return {
    isLoading: Boolean(isLoading),
    headerPartId: safePartIds[0],
    featuresData: featuresData || {},
  };
};
